module.exports = __webpack_public_path__ + "img/GP.3ecc74aa.svg";